import { motion } from "framer-motion";
import "./App.css";

const pageTransition = (OgComponent) => {
    return () => (
        <>
            <OgComponent />
            <motion.div
                className="slide-in"
                initial={{ scaleY: 1 }}
                animate={{ scaleY: 0 }}
                exit={{ scaleY: 1 }}
                transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            >
            </motion.div>
            {/* <motion.div
                className="slide-out"
                initial={{ scaleY: 1}}
                animate={{ scaleY: 0}}
                exit={{ scaleY: 0}}
                transition={{ duration: 1, ease: [0.22, 1, 0.36, 1]}}
            > */}
            {/* <div
                    className="transition-icon">
                    <svg className="transition" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 167.45 92.81">
                        <path class="cls-1" d="m167.45,92.81L109.68,0l-26.41,42.43L56.85,0,0,91.33h7.4L56.85,11.88l22.71,36.49-27.66,44.44h115.55ZM109.68,11.88l46.47,74.65h-45.43l-23.76-38.16,22.71-36.49Zm-6.35,74.65h-40.12l20.06-32.22,20.06,32.22Z"/>
                    </svg>
                </div> */}
            {/* </motion.div> */}
        </>
    );
};

export default pageTransition;